import { ID, Response } from 'app/components/Table/core/types';

import { SensorConnectionStatus } from 'app/modules/inventory/bins/core/enum';
import { Bin } from 'app/modules/inventory/bins/core/type';
import { Rack } from 'app/modules/inventory/racks/core/type';
import { Ward } from 'app/modules/system-settings/locations/wards/core/type';

import { DeviceType, SensorType } from './enum';

export type Device = {
  id: ID;
  name: string;
  createdAt: string;
  updatedAt: string;
  macAddress: string;
  typeSub: DeviceType;
  wardId: number;
  code: string;
  expired: string;
  info: string;
  linked: boolean;
  inventoryLocation?: {
    location: Ward;
    bin: Bin;
  };
  skuId?: string;
};

export type Sensor = {
  id: ID;
  code: string;
  wardId: number;
  orgId: number;
  type: SensorType;
  createdAt: string;
  updatedAt: string;
  skuId: string;
  inventoryLocation?: {
    location: Ward;
    bin: Bin;
    rack: Rack;
  };
  piId: string;
  cameraId: string;
  viewId: string;
  hangerId?: string;
  heartbeatStatus: SensorConnectionStatus;
  name?: string;
  baseWeight?: number;
};

export type DevicesQueryResponse = Response<{
  items: Array<Device>;
  total: number;
}>;

export type SensorsQueryResponse = Response<{
  items: Array<Sensor>;
  total: number;
}>;

export type DeviceRequest = {
  name: string;
  typeSub?: DeviceType;
  wardId: number;
};

export type SensorRequest = {
  code: string;
  type: string;
  wardId: number;
  piId?: string;
  cameraId?: string;
  viewId?: string;
  hangerId?: string;
};

export const initialDeviceRequest: DeviceRequest = {
  name: '',
  wardId: 0,
};

export type BinAssetType = 'image' | 'video';

export interface PreviewFile {
  url: string;
  type: BinAssetType;
}

export interface BinAsset {
  id: number;
  name: string;
  url: string;
  type: string;
  createdAt: string;
}

export interface VisualArchiveFilterParams {
  fromDate?: Date | null;
  toDate?: Date | null;
}

export interface DeviceSensorFilterParams {
  status?: SensorConnectionStatus[];
  locationIds?: string[];
  page?: number;
}
